import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { triggerBrowserDownload } from "../utils/triggerDownload";

const fetchPlans = async (status) => {
  const { data } = await axios.get("/plans", { params: { status } });
  return data;
};

const createPlan = async (payload) => {
  const { data } = await axios.post("/plans", payload);
  return data;
};

const archivePlan = async ({ planId, action }) => {
  const { data } = await axios.patch(`/plans/${planId}/archive`, { action });
  return data;
};

const deletePlan = async ({ planId }) => {
  const { data } = await axios.delete(`/plans/${planId}`);
  return data;
};

const downloadPlan = async ({ planId }) => {
  const { data } = await axios.get(`/plans/${planId}/export`);
  return data;
};

// Custom hooks
export const usePlans = (status = "active") => {
  return useQuery({
    queryKey: ["plans", status],
    queryFn: () => fetchPlans(status),
    placeholderData: { plans: [], activeCount: 0, archivedCount: 0 },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useCreatePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPlan,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["plans"] });
    },
    onError: (error) => {
      console.error("Error creating plan:", error);
      throw error;
    },
  });
};

export const useArchivePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: archivePlan,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["plans"] });
    },
    onError: (error) => {
      console.error("Error archiving/unarchiving plan:", error);
      throw error;
    },
  });
};

export const useDeletePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deletePlan,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["plans"] });
    },
    onError: (error) => {
      console.error("Error deleting plan:", error);
      throw error;
    },
  });
};

export const useDownloadPlan = () => {
  return useMutation({
    mutationFn: downloadPlan,
    onSuccess: (data) => {
      if (data?.downloadUrl) triggerBrowserDownload(data.downloadUrl);
    },
    onError: (error) => {
      console.error("Error downloading plan:", error);
      throw error;
    },
  });
};

export default {
  usePlans,
  useCreatePlan,
  useArchivePlan,
  useDeletePlan,
  useDownloadPlan,
};
